import {
	BooleanOptionValueDto,
	DecimalOptionValueDto,
	IntegerOptionValueDto,
	ObjectOptionValueDto,
	OptionsDto,
	OptionValueDto,
	StringOptionValueDto,
	TimeStampOptionValueDto,
	Types,
} from '@siza-staff-care/shared/data';

export const extractOptions = <T = Record<string, unknown>>(options: OptionsDto): T => {
	const ignoreNames = ['ceased', 'ceasedDate', 'vClassName'];

	const result: Record<string, unknown> = {};

	(options?.values || []).forEach((v: OptionValueDto) => {
		if (ignoreNames.indexOf(v.name) >= 0) {
			return;
		}

		switch (v.$type) {
			case Types.BooleanOptionValueDto:
				result[v.name] = (v as BooleanOptionValueDto).value;
				break;
			case Types.IntegerOptionValueDto:
				result[v.name] = (v as IntegerOptionValueDto).value;
				break;
			case Types.DecimalOptionValueDto:
				result[v.name] = (v as DecimalOptionValueDto).value;
				break;
			case Types.StringOptionValueDto:
				result[v.name] = (v as StringOptionValueDto).value;
				break;
			case Types.TimeStampOptionValueDto:
				result[v.name] = (v as TimeStampOptionValueDto).value;
				break;
			case Types.ObjectOptionValueDto:
				result[v.name] = (v as ObjectOptionValueDto).value;
				break;
		}
	});

	return result as T;
};
